import '@styles/views/bentley.less';
import AppFooter from '@components/app/appFooter';

const Bentleproduct = () => {
  const fnList = [
    { name: 'Context Capture', introduction: '三维实景建模' },
    { name: 'MicroStation', introduction: '三维CAD' },
    { name: 'PLAXIS', introduction: '岩土工程分析' },
    { name: 'gINT', introduction: '地质勘察数据模拟' },
    { name: 'CUBE', introduction: '交通规划仿真' },
    { name: 'LEGION', introduction: '人流分析模拟' },
    { name: 'OpenRoads', introduction: '土木工程设计' },
    { name: 'SYNCHRO', introduction: '施工模拟' },
    { name: 'Open Buildings', introduction: '土建建模' },
    { name: 'ProStructures', introduction: '钢结构建模' },
    { name: 'Substation', introduction: '智能化变电站电气设计系统' },
    { name: 'OpenFlows', introduction: '水力模型建模' },
    { name: 'OpenPlant', introduction: '三维工厂设计' },
    { name: 'Lumen RT', introduction: '可视化和实景建模' },
    { name: 'iTwin', introduction: '数字孪生技术' },
    { name: 'Asset Wise', introduction: '资产全生命周期信息管理' },
    { name: 'ProjectWise', introduction: '文档管理' },
    { name: 'Navigator', introduction: 'BIM模型审查和协同工作' },
    { name: 'Emme', introduction: '多模式交通规划' },
    { name: '添加跨世纪官方微信', introduction: '索取产品电子资料' },
  ];

  const fnListJSX = fnList.map((item) => {
    return (
      <div className={'item bentley fn'} key={item.name}>
        <p className={'name'}>{item.name}</p>
        <p className={'introduction'}>{item.introduction}</p>
      </div>
    );
  });
  return (
    <div className={'about-pageN'}>
      <div className={'content-titleN'}>
        <img
          className={'bentleyLogo'}
          src={require('@images/common/Bentleylogo.png').default}
          alt=""
        />
        <span className={'text'}>Bentley 产品</span>
        <img
          className={'bentleyLogobg'}
          src={require('@images/common/Bentleylogobg.png').default}
          alt=""
        />
      </div>
      <div className={'introduceNew'}>
        <div className={'content'}>
          <div>{fnListJSX}</div>
        </div>
      </div>
      <AppFooter />
    </div>
  );
};

export default Bentleproduct;
